export default __webpack_public_path__ + "static/media/chiya_think_tummoc.079de8a7.png";